import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppState } from '../../../app.state';
import { Customer } from '../../models/customer/customer.model';
import { CustomerService } from '../../services/customer/customer.service';
import { UtilityService } from '../../services/utility/utility.service';

@Component({
    selector: 'upsc-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss'],
})
export class PrivacyComponent implements OnInit {
    public privacyTerms: string;
    private customer: Customer;

    public constructor(private translateService: TranslateService,
                       private appState: AppState,
                       private customerService: CustomerService,
                       private readonly utilityService: UtilityService,
    ) {
    }

    public ngOnInit(): void {
        this.loadPolicyTermsText();
    }

    private loadPolicyTermsText(): void {
        const customer = this.appState.customer$();
        const customerLanguage = this.customerService.getCustomerLanguage(customer);
        const siteLanguage = this.utilityService.getSiteLanguage();
        const language = this.customer ? customerLanguage : siteLanguage;
        this.translateService.use(language).subscribe(
            () => {
                this.privacyTerms = this.translateService.instant('privacyTerms');
            },
        );
    }
}
